import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { Order } from '../Order'
import { Field, ID, InputType } from 'type-graphql'

/**
 * Args for settling an on-account (credit) order. Records a real on-account
 * payment for the order's current balance so the order becomes Fully Paid and
 * leaves AR — replacing the legacy fake-cash workaround.
 */
@InputType()
export class MarkOrderSettledArgs extends ActionArgs {
  @Field(() => ID)
  orderId: string
}

export interface IMarkOrderSettled extends IAction<Order, MarkOrderSettledArgs> {}
